import { styled, Tooltip, tooltipClasses, TooltipProps } from '@mui/material';
import { cloneElement, ComponentPropsWithRef, createRef, useMemo } from 'react';
import classes from './Tooltip.module.scss';

export const NbTooltip = styled(({ className, children, ...props }: TooltipProps & { dataTestId?: string }) => {
  const isSvg = typeof children === 'object' && children.type === 'svg';
  const iconRef = createRef();

  const SvgElement = useMemo(() => {
    if (isSvg) {
      // From React 19 forwardRefs are getting deprecated: https://react.dev/blog/2024/12/05/react-19#ref-as-a-prop
      return (props: ComponentPropsWithRef<any>) => cloneElement(children, props);
    }
    return () => <></>;
    // eslint-disable-next-line react-hooks/exhaustive-deps -- isSvg doesn't need to be in the dependency array
  }, [children]);

  return (
    <Tooltip
      {...props}
      classes={{ popper: className, arrow: classes.tooltipArrow }}
      arrow
      ref={iconRef}
    >
      {isSvg ? <SvgElement ref={iconRef} /> : children}
    </Tooltip>
  );
})(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: classes.colorBackground,
    color: classes.colorText,
    fontWeight: classes.fontWeight,
    fontSize: classes.fontSize,
    lineHeight: classes.lineHeight,
  },
}));
